// Import the necessary components
import { Record } from 'js-data'
import { map, isInteger, isArray, snakeCase } from 'lodash'

class VerofreshRecord extends Record {
  static get icon () {
    return undefined
  }

  /**
   * Returns the name of this class (e.g. RouteRecord, etc...)
   *
   * @return string
   */
  getClass () {
    return this.$className
  }

  /**
   * Returns this type of this record e.g. a (RouteRecord would return 'route'
   * and a RouteLocationRecord would return route_record). This is useful for
   * all sorts of purposes such as getting the translation of the resource
   * name, etc...
   *
   * @return string
   */
  getType () {
    return snakeCase(this.$className.replace(/Record$/g, ''))
  }

  /**
   * Returns an array if customer ids to which this resource is associated. Be
   * aware that if the component that loaded this resources did not include
   * customer information that this will return undefined even through it may
   * be in fact associated with a customer(s)
   *
   * @return undefined|array
   */
  getCustomerIds () {
    if (isArray(this.customers)) {
      return map(this.customers, 'id')
    }

    if (isInteger(this.customer_id)) {
      return [this.customer_id]
    }
  }
}

export default VerofreshRecord
